(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    const menuItems = document.querySelectorAll('.custom-menu-item');

    function updateMegaPosition(item) {
      if (!item) return;
      const mega = item.querySelector('.custom-submenu--mega');
      if (!mega) return;

      const rect = item.getBoundingClientRect();
      mega.style.setProperty('--mega-left-offset', `${rect.left}px`);
    }

    function updateAllMegaPositions() {
      menuItems.forEach((item) => updateMegaPosition(item));
    }

    function closeAllMenus(exceptItem = null) {
      menuItems.forEach((item) => {
        if (item !== exceptItem) {
          item.classList.remove('is-open');
          const toggle = item.querySelector('.custom-menu-toggle');
          const submenu = item.querySelector('.custom-submenu');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
          if (submenu) submenu.hidden = true;
        }
      });
      document.documentElement.classList.remove('custom-menu-drawer-open');
      document.body.classList.remove('custom-menu-drawer-open');
    }

    function openMenu(item) {
      closeAllMenus(item);
      updateMegaPosition(item);

      item.classList.add('is-open');

      const toggle = item.querySelector('.custom-menu-toggle');
      const submenu = item.querySelector('.custom-submenu');

      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (submenu) submenu.hidden = false;

      if (item.dataset.menuType === 'drawer') {
        document.documentElement.classList.add('custom-menu-drawer-open');
        document.body.classList.add('custom-menu-drawer-open');
      }
    }

    function toggleMenu(item) {
      const isOpen = item.classList.contains('is-open');
      if (isOpen) {
        closeAllMenus();
      } else {
        openMenu(item);
      }
    }

    menuItems.forEach((item) => {
      const triggerMode = item.dataset.triggerMode;
      const toggle = item.querySelector('.custom-menu-toggle');
      const submenu = item.querySelector('.custom-submenu');

      if (!toggle || !submenu) return;

      if (triggerMode === 'hover') {
        item.addEventListener('mouseenter', () => openMenu(item));
        item.addEventListener('mouseleave', () => closeAllMenus());
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          toggleMenu(item);
        });
      } else {
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          toggleMenu(item);
        });
      }

      const closeBtn = item.querySelector('.custom-drawer-close');
      const overlay = item.querySelector('.custom-drawer-overlay');

      if (closeBtn) {
        closeBtn.addEventListener('click', () => closeAllMenus());
      }

      if (overlay) {
        overlay.addEventListener('click', () => closeAllMenus());
      }
    });

    window.addEventListener('resize', updateAllMegaPositions);
    window.addEventListener('scroll', updateAllMegaPositions, { passive: true });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.custom-desktop-menu')) {
        closeAllMenus();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeAllMenus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
